module.exports = __webpack_public_path__ + "static/media/team.47cf6b5a.svg";